import type { ClientPropertyCottageDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { COTTAGE_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/CottageForm/cottageFormDefaults";
import type { CottageFormInput } from "web_myplann/Portfolio/Forms/CottageForm/cottageFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPropertyToCottageForm = (
	property: ClientPropertyCottageDetailResponseDTO,
): CottageFormInput => ({
	location: property.location ?? DEFAULTS.location,
	locationMunicipality:
		property.locationMunicipality ?? DEFAULTS.locationMunicipality,
	locationZipCode: property.locationZipCode ?? DEFAULTS.locationZipCode,
	usableArea: property.usableArea ?? DEFAULTS.usableArea,
	floorArea: property.floorArea ?? DEFAULTS.floorArea,
	disposition: property.disposition ?? DEFAULTS.disposition,
	buildingMaterial: property.buildingMaterial ?? DEFAULTS.buildingMaterial,
	numberOfFloors: property.numberOfFloors ?? DEFAULTS.numberOfFloors,
	interiorValue: property.interiorValue ?? DEFAULTS.interiorValue,
	purchaseDate: parseIsoDate(property.purchaseDate),
	description: property.description ?? DEFAULTS.description,
	terrace: property.terrace ?? DEFAULTS.terrace,
	loggia: property.loggia ?? DEFAULTS.loggia,
	balcony: property.balcony ?? DEFAULTS.balcony,
	garage: property.garage ?? DEFAULTS.garage,
	cellar: property.cellar ?? DEFAULTS.cellar,
	elevator: property.elevator ?? DEFAULTS.elevator,
	barrierFree: property.barrierFree ?? DEFAULTS.barrierFree,
	swimmingPool: property.swimmingPool ?? DEFAULTS.swimmingPool,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
